import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { BRIDAL_CATEGORIES, waLink, WA_MESSAGES } from "@/config/site";
import { openBooking } from "@/lib/api";

const Bridal = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <section ref={ref} className="relative py-32 sm:py-48 overflow-hidden grain" data-testid="bridal-experience">
            <motion.div className="absolute inset-0" style={{ y: bgY }}>
                <img
                    src="/images/bridal-new.jpg"
                    alt="Punjabi bride in heritage gold bridal jewellery by BSK Jewellers, Amritsar"
                    loading="lazy"
                    className="w-full h-[124%] object-cover"
                />
            </motion.div>
            <div className="absolute inset-0 bg-obsidian/72" />
            <div className="absolute inset-0 bg-gradient-to-b from-obsidian via-transparent to-obsidian" />

            <div className="relative max-w-[1100px] mx-auto px-5 sm:px-8 text-center">
                <Reveal>
                    <span className="eyebrow" data-testid="bridal-eyebrow">The Bridal Atelier</span>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl leading-[1.1] mt-6">
                        For the Bride. For the Moment. <span className="italic gold-text">Forever.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="text-sand text-sm sm:text-base max-w-xl mx-auto mt-6 leading-relaxed">
                        Discover jewellery created to become part of the memories you'll carry for a lifetime.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <div className="flex flex-wrap justify-center gap-2.5 mt-9">
                        {BRIDAL_CATEGORIES.map((c) => (
                            <Link
                                key={c}
                                to="/collections?collection=bridal"
                                data-testid={`bridal-cat-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="text-[10px] tracking-[0.24em] uppercase text-ivory/85 border border-ivory/25 px-4 py-2 hover:border-gold hover:text-gold transition-colors duration-300"
                            >
                                {c}
                            </Link>
                        ))}
                    </div>
                </Reveal>
                <Reveal delay={0.4}>
                    <div className="flex flex-col sm:flex-row justify-center gap-4 mt-11">
                        <Link
                            to="/collections?collection=bridal"
                            data-testid="bridal-explore-btn"
                            className="bg-gold text-obsidian text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:bg-gold-bright transition-colors"
                        >
                            Explore Bridal Collection
                        </Link>
                        <a
                            href={waLink(WA_MESSAGES.bridal)}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="bridal-consultation-btn"
                            className="border border-ivory/40 text-ivory text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:border-gold hover:text-gold transition-colors"
                        >
                            Book Bridal Consultation
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Bridal;
